import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _Promise from "babel-runtime/core-js/promise";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import org from "@/tools/org";
import oppService from "@/service/opp-service";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";

var backfillOldData = function backfillOldData(_this) {
  var acctAssetInfo = _.cloneDeep(_this.oppBusiData.oldBusiData.acctAssetInfo);
  if (!_.isEmpty(acctAssetInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], acctAssetInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var bankInfoList = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (bankInfoList && bankInfoList.length) {
    bankInfoList = bankInfoList[0];

    if (bankInfoList && bankInfoList["EXT_ORG"]) {
      bankInfoList["NEW_EXT_ORG"] = bankInfoList["EXT_ORG"];
      bankInfoList["NEW_EXT_ORG_DATA_SOURCE"] = bankInfoList["EXT_ORG_DATA_SOURCE"];
    }
    if (!_.isEmpty(bankInfoList)) {
      bankInfoList.POSITION_REMARK = _.cloneDeepGet(_this.historyData, "DETAIL_DATA.OPER_REMARK", "");
      _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], bankInfoList);
      _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], bankInfoList);
    }
  }

  var acctAssetInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH2);
  if (acctAssetInfo && acctAssetInfo.length) {
    acctAssetInfo = acctAssetInfo[0];
    if (!_.isEmpty(acctAssetInfo)) {
      _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], acctAssetInfo);
      _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], acctAssetInfo);
    }
  }
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

  fields.NEW_ACCOUNT_CODE.IS_SHOW_BUTTON = true;
  fields.NEW_ACCOUNT_CODE.VALID_TYPE = "pur_num|on-blur";
  fields.NEW_ACCOUNT_CODE.FIELD_BUTTON_TXT = "自动生成";
  fields.NEW_ACCOUNT_CODE.skipCheck = "1";

  fields.POSITION_REMARK.PLACE_HOLDER = "开纯资金账户，必须填写备注信息";
};

var getDepositoryBank = function getDepositoryBank(_this) {
  var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO);

  return _Promise.all([_this.$syscfg.K_Request("F0000075", {
    CUST_CODE: "0",
    CURRENCY: "0",
    INT_ORG: customerInfo.INT_ORG,
    CUBSB_TYPE: "1" }), org.getOrgData()]).then(function (res) {
    _this.oppBusiData.EXT_ORG_LIST = [];
    var bankList = res[0].Data || [];
    var list = res[1] || [];

    var ORG_INFO = [];

    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].ORG_CLS === "11" && list[i].ORG_CODE[list[i].ORG_CODE.length - 1] === "0") {
        ORG_INFO.push(list[i]);
      }
    }

    for (var _i = 0, _l = bankList.length; _i < _l; _i++) {
      for (var j = 0, len = ORG_INFO.length; j < len; j++) {
        if (bankList[_i].EXT_ORG == ORG_INFO[j].ORG_CODE) {
          if (ORG_INFO[j].ORG_CODE !== "6400") {
            _this.oppBusiData.EXT_ORG_LIST.push({
              DICT_ITEM: ORG_INFO[j].ORG_CODE,
              DICT_ITEM_NAME: ORG_INFO[j].ORG_FULL_NAME
            });
          }
        }
      }
    }
    _this.oppBusiData.EXT_ORG_LIST = _.orderBy(_this.oppBusiData.EXT_ORG_LIST, ["DICT_ITEM"], "asc");
    return true;
  }).catch(function (err) {
    console.error("getDepositoryBank失败", err);
  });
};

var validatedCuacctCodeFun = function validatedCuacctCodeFun(_this, field, fields) {
  if (field.DEFAULT_VALUE == "") {
    return _Promise.resolve(false);
  }
  if (field.DEFAULT_VALUE != _this.oppBusiData.validatedCuacctCode) {
    _this.oppBusiData.cuacctCodeValidateFlag = "0";
  }
  if (_this.oppBusiData.cuacctCodeValidateFlag != "1") {
    var custInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {};
    return _this.$syscfg.K_Request("Y3003507", {
      CUACCT_CODE: field.DEFAULT_VALUE,
      CUACCT_USES: "0",
      ORG_CODE: custInfo.INT_ORG
    }, true, true).then(function (res) {
      if (res.Code != 0) {
        if (res.Code == "12000242") {
          return new _Promise(function (resolve) {
            _this.$blMethod.showMsgBox(_this, "指定的资产帐号" + field.DEFAULT_VALUE + "属于资产账户预留账户是否继续往下操作?", function () {
              _this.oppBusiData.cuacctCodeValidateFlag = "1";
              _this.oppBusiData.validatedCuacctCode = field.DEFAULT_VALUE;
              resolve(true);
            }, function () {
              field.DEFAULT_VALUE = "";
              _this.oppBusiData.cuacctCodeValidateFlag = "0";

              field.FIELD_CONTROL = "0";
              field.BUTTON_ENABLE = false;
              resolve(false);
            }, "确认", "取消");
          });
        } else {
          var msg = res.Msg;
          msg = msg.substring(msg.lastIndexOf(":") + 1, msg.length - 2);
          _this.alert(msg);
          _this.oppBusiData.cuacctCodeValidateFlag = "0";

          field.FIELD_CONTROL = "0";
          field.BUTTON_ENABLE = false;
          return false;
        }
      } else {
        _this.oppBusiData.validatedCuacctCode = field.DEFAULT_VALUE;
        _this.oppBusiData.cuacctCodeValidateFlag = "1";
        return true;
      }
    });
  } else {
    return _Promise.resolve(true);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }

    return _this.oppBusiData.NEED_SHOW_MOBILE_TIP_BANK = oppService.getSysCommonParamsFromCacheObjs("NEED_SHOW_MOBILE_TIP_BANK").then(function (val) {
      _this.oppBusiData.NEED_SHOW_MOBILE_TIP_BANK = val || "5700";
      return getDepositoryBank(_this);
    });
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    _this.oppBusiData.isAccountNextClick = _.get(_this, "historyData.DETAIL_DATA.isAccountNextClick", "0");

    _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.NEW_EXT_ORG.FIELD_DICT_NAME = _this.oppBusiData.EXT_ORG_LIST;
    backfillHistoryData(_this);
    _this.oppBusiData.cuacctCodeValidateFlag = _.get(_this, "historyData.DETAIL_DATA.cuacctCodeValidateFlag");

    if (_.get(_this.historyData, "BIZ_DATA.CUACCT_INFO_LIST[0].NEW_ACCOUNT_CODE", "") && _this.oppBusiData.isAccountNextClick == "1") {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.NEW_ACCOUNT_CODE.FIELD_CONTROL = "2";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.NEW_ACCOUNT_CODE.BUTTON_ENABLE = true;
    }

    if (_this.oppBusiData.cuacctCodeValidateFlag == "1" && _this.oppBusiData.isAccountNextClick == "1") {
      _this.oppBusiData.validatedCuacctCode = _.get(_this, "historyData.BIZ_DATA.CUACCT_INFO_LIST[0].NEW_ACCOUNT_CODE", "");
    }

    _this.oppBusiData.autoCuacctCode = _.get(_this, "historyData.DETAIL_DATA.autoCuacctCode");
  },
  preValidate: function preValidate(_this) {
    _this.removeFlowTip("addressTip");
    _this.removeFlowTip("mobileTip");
  },
  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var initProCls, proCls, assetInfo, NEW_ACCOUNT_CODE, CURRENCY, CUACCT_CLS, CUACCT_LVL, CUACCT_GRP, CUACCT_ATTR, CUACCT_CLS_FEE_SN;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              consoleLog("开户模板为", _this.oppBusiData.OPENTMPL_INFO);
              _this.removeFlowTip("addressTip");
              _this.removeFlowTip("mobileTip");
              _this.oppBusiData.OPENTMPL_INFO.OLD_CHANNELS = _this.oppBusiData.OPENTMPL_INFO.OLD_CHANNELS || _this.oppBusiData.OPENTMPL_INFO.CHANNELS;
              if (_this.busiCode == "QS421") {
                initProCls = _.get(params, "BIZ_DATA.PRODUCT_INFO.PRO_CLS");
                proCls = initProCls ? initProCls.slice(0, 2) : "";

                if (["23"].includes(proCls)) {
                  _this.oppBusiData.OPENTMPL_INFO.CHANNELS = "0B";
                } else if (_.get(params, "BIZ_DATA.PRODUCT_INFO.PRO_CLS") == "01") {
                  _this.oppBusiData.OPENTMPL_INFO.CHANNELS = "026B";
                }
              }

              _.set(params, "BIZ_DATA.OPENTMPL_INFO", _this.oppBusiData.OPENTMPL_INFO || {});
              assetInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2]);

              assetInfo["EXT_ORG"] = assetInfo["NEW_EXT_ORG"];

              assetInfo.SIGN_TYPE = "1";
              assetInfo.BANK_AUTH_DATA = "";
              assetInfo.CUBSB_TRD_ID = "17";
              assetInfo.BANK_AUTH_DATA = "";
              assetInfo.CURRENCY = "0";

              params.DETAIL_DATA.cuacctCodeValidateFlag = _this.oppBusiData.cuacctCodeValidateFlag;
              delete assetInfo["NEW_EXT_ORG"];
              NEW_ACCOUNT_CODE = assetInfo.NEW_ACCOUNT_CODE;

              delete assetInfo["NEW_ACCOUNT_CODE"];
              CURRENCY = "0";
              CUACCT_CLS = _this.oppBusiData.OPENTMPL_INFO && _this.oppBusiData.OPENTMPL_INFO.CUACCT_CLS || "1";
              CUACCT_LVL = _this.oppBusiData.OPENTMPL_INFO && _this.oppBusiData.OPENTMPL_INFO.CUACCT_LVL || "";
              CUACCT_GRP = _this.oppBusiData.OPENTMPL_INFO && _this.oppBusiData.OPENTMPL_INFO.CUACCT_GRP || "";
              CUACCT_ATTR = _this.oppBusiData.OPENTMPL_INFO && _this.oppBusiData.OPENTMPL_INFO.CUACCT_ATTR || "";
              CUACCT_CLS_FEE_SN = _this.oppBusiData.OPENTMPL_INFO && _this.oppBusiData.OPENTMPL_INFO.CUACCT_CLS_FEE_SN || "";

              params.BIZ_DATA.CUACCT_CODE = NEW_ACCOUNT_CODE;

              params.DETAIL_DATA.autoCuacctCode = _this.oppBusiData.autoCuacctCode;
              params.DETAIL_DATA.isAccountNextClick = _this.oppBusiData.isAccountNextClick || "0";
              params.DETAIL_DATA.OPER_REMARK = assetInfo.POSITION_REMARK;
              params.DETAIL_DATA.POSITION_REMARK_UPDATE_FLAG = assetInfo.POSITION_REMARK_UPDATE_FLAG;

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], assetInfo);
              _.set(params, SAVE_PATH, [assetInfo]);
              _.set(params, SAVE_PATH2, [{ NEW_ACCOUNT_CODE: NEW_ACCOUNT_CODE, CURRENCY: CURRENCY, CUACCT_CLS: CUACCT_CLS, CUACCT_LVL: CUACCT_LVL, CUACCT_GRP: CUACCT_GRP, CUACCT_ATTR: CUACCT_ATTR, CUACCT_CLS_FEE_SN: CUACCT_CLS_FEE_SN }]);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      var fields, codeField, flag;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              fields = _this.moduleDatas[MODULE_ID][0].FIELDS;
              codeField = fields.NEW_ACCOUNT_CODE;

              if (codeField.DEFAULT_VALUE) {
                _context2.next = 7;
                break;
              }

              alert("资产帐号不能为空！");

              codeField.FIELD_CONTROL = "0";
              codeField.BUTTON_ENABLE = false;
              return _context2.abrupt("return", false);

            case 7:
              flag = true;

              if (_this.oppBusiData.autoCuacctCode) {
                _context2.next = 12;
                break;
              }

              _context2.next = 11;
              return validatedCuacctCodeFun(_this, codeField, fields);

            case 11:
              flag = _context2.sent;

            case 12:
              if (!_.get(_this, "historyData.BIZ_DATA.CUACCT_CODE")) {
                _this.oppBusiData.validateResArr.push({
                  alertType: "confirm",
                  messageText: "请确认是否使用该资产账号？确定后将不可修改！"
                });
              }
              if (flag) {
                _this.oppBusiData.isAccountNextClick = "1";
              }
              return _context2.abrupt("return", flag);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),
  pageActivated: function pageActivated(_this, groupId) {

    if (_.get(_this.historyData, "BIZ_DATA.CUACCT_INFO_LIST[0].NEW_ACCOUNT_CODE", "") && _this.oppBusiData.isAccountNextClick == "1") {
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.NEW_ACCOUNT_CODE.FIELD_CONTROL = "2";
      _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.NEW_ACCOUNT_CODE.BUTTON_ENABLE = true;
    }
    if (_this.oppBusiData.cuacctCodeValidateFlag == "1" && _this.oppBusiData.isAccountNextClick == "1") {
      _this.oppBusiData.validatedCuacctCode = _.get(_this, "historyData.BIZ_DATA.CUACCT_INFO_LIST[0].NEW_ACCOUNT_CODE", "");
    }
    _this.oppBusiData.cuacctCodeValidateFlag = _.get(_this, "historyData.DETAIL_DATA.cuacctCodeValidateFlag");
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},
  CHECK_NEW_ACCOUNT_CODE: function CHECK_NEW_ACCOUNT_CODE(_this, field, fieldData, module, index, type) {
    if (_this.oppBusiData.autoCuacctCode != field.DEFAULT_VALUE && type == "0") {
      _this.oppBusiData.autoCuacctCode = "";
      validatedCuacctCodeFun(_this, field, fieldData);
    }
  },

  CHECK_NEW_ACCOUNT_CODE__CLICK: function CHECK_NEW_ACCOUNT_CODE__CLICK(_this, field, fieldData) {
    var custInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {};
    _this.myLoading({
      loadingText: "正在生成资产账号...",
      autoHide: false
    });
    if (!custInfo.INT_ORG) {
      alert("生成资产账号失败，客户机构不能为空！");
      _this.myLoading({
        showLoading: false
      });
      return;
    }
    _this.oppBusiData.autoCuacctCode = "";
    _this.$syscfg.K_Request("Y3003507", {
      CUACCT_CODE: "0",
      CUACCT_USES: "0",
      ORG_CODE: custInfo.INT_ORG
    }).then(function (res) {
      var info = res.Data[0];
      _this.oppBusiData.cuacctCodeValidateFlag = "1";
      _this.oppBusiData.validatedCuacctCode = info.CUACCT_CODE;

      _this.oppBusiData.autoCuacctCode = info.CUACCT_CODE;
      field.DEFAULT_VALUE = info.CUACCT_CODE;

      _this.myLoading({
        showLoading: false
      });
    });
  },
  CHECK_NEW_EXT_ORG: function CHECK_NEW_EXT_ORG(_this, field, fieldData) {
    if (field.DEFAULT_VALUE) {
      _this.removeFlowTip("addressTip");
      _this.removeFlowTip("mobileTip");
      if (field.DEFAULT_VALUE == "5400") {
        _this.pushFlowTip({
          title: "请确保办公地址不超过60个字符（30个汉字），否则银行签约可能会失败。",
          key: "addressTip",
          type: "warning"
        });
      }
      var needShowMobileTip = _this.oppBusiData.NEED_SHOW_MOBILE_TIP_BANK.split(",");
      if (needShowMobileTip.includes(field.DEFAULT_VALUE)) {
        _this.pushFlowTip({
          title: "请确保客户的联系人的联系电话录入移动电话，否则银行签约可能会失败。",
          key: "mobileTip",
          type: "warning"
        });
      }
      _this.myLoading({

        loadingText: "正在获取银证配置...",
        autoHide: false
      });
      _this.$syscfg.K_Request("Y3000015", {
        INT_ORG: _.get(_this.oppBusiData, "OPENTMPL_INFO.INT_ORG", "0"),
        EXT_ORG: field.DEFAULT_VALUE,
        CURRENCY: "0",
        CUBSB_TRD_ID: "17"
      }).then(function (res) {
        var data = res.Data[0];
        if (data.CUBSB_TRD_ID != "17") {
          _this.alert("该银行不支持签约，请重新选择！");
          field.DEFAULT_VALUE = "";
        }
        _this.myLoading({
          showLoading: false
        });
      });
    }
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizAcct/bizAcctAssetInfoNode.js
// module id = 166
// module chunks = 2